/*
 * WB custom: Shipping / Pickup chooser on the product page (snippets/fulfillment-options.liquid).
 * - Selects the shopper's last choice when it's available for this variant, otherwise Shipping,
 *   otherwise whatever is available.
 * - When Pickup is chosen, enables the hidden "properties[Fulfillment]=Pickup" input so the
 *   choice is added to the cart item; Shipping sends nothing.
 * - The markup is re-rendered on variant change, so the choice is kept in sessionStorage.
 */
if (!customElements.get('fulfillment-options')) {
  class FulfillmentOptions extends HTMLElement {
    static storageKey = 'wb-fulfillment-choice';

    connectedCallback() {
      this.radios = Array.from(this.querySelectorAll('input[type="radio"]'));
      this.propertyInput = this.querySelector('[data-fulfillment-property]');
      this.locationInfo = this.querySelector('[data-pickup-location]');

      let preferred = null;
      try {
        preferred = sessionStorage.getItem(FulfillmentOptions.storageKey);
      } catch (e) {}

      const enabled = this.radios.filter(radio => !radio.disabled);
      const initial =
        enabled.find(radio => radio.value === preferred) ||
        enabled.find(radio => radio.value === 'Shipping') ||
        enabled[0];
      if (initial) initial.checked = true;

      this.radios.forEach(radio => {
        radio.addEventListener('change', () => {
          if (!radio.checked) return;
          try {
            sessionStorage.setItem(FulfillmentOptions.storageKey, radio.value);
          } catch (e) {}
          this.update();
        });
      });

      this.update();
    }

    update() {
      const selected = this.radios.find(radio => radio.checked);
      const isPickup = Boolean(selected && selected.value === 'Pickup');

      if (this.propertyInput) this.propertyInput.disabled = !isPickup;
      if (this.locationInfo) this.locationInfo.hidden = !isPickup;

      this.radios.forEach(radio => {
        radio.closest('.fulfillment-options__tile')?.classList.toggle('is-selected', radio.checked);
      });
    }
  }

  customElements.define('fulfillment-options', FulfillmentOptions);
}
